<div class="broker-plan-payment-options position-relative">
    <div class="position-absolute  cursor-pointer close-button" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </div>
    <div class="avatar flex-centered-container">
        <img src="/assets/icons/logo-compact.png">
    </div>

    <div class="text-center font-16 margin-8-bottom" *ngIf="downgradablePlan">
        {{DOWNGRADE_CONFIRMATION}}
    </div>

    <div class="plan-details padding-hr pad-8-vr align-items-center border-field chamfer-xl margin-8-hr margin-8-bottom">
        <div  class="flex-space-between align-items-center">
            <div class="display-flex align-items-center mat-icon-18 pad-4-vr">
                <mat-icon class="pad-8-right fg-accent">check_circle_rounded</mat-icon>
                <span class="font-14 font-bold">{{planData.planName}} Plan</span>
            </div>
            <div class="cursor-pointer decoration-underline text-accent font-12" *ngIf="!hideChangePlan"  (click)="closeDialog()">Change Plan</div>
        </div>
    </div>

    <mat-accordion class="margin-24-bottom coupon-expansion-panel" *ngIf="!downgradablePlan">
        <mat-expansion-panel class="border-field chamfer-xl" [expanded]="expandDiscountExpansionPanel">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div class="flex-space-between full-width">
                        <span  class="font-bold font-14">Coupon</span>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <form [formGroup]="discountForm" [ngClass]="{'align-items-center': isExclusiveCoupon}" class="flex-space-between  margin-8-top font-14 full-width policies-text">
                <input *ngIf="!isExclusiveCoupon" matInput formControlName="discountCoupon" placeholder="Enter coupon code" class="width-60 border-field chamfer-xl pad-8">
                <ng-container *ngIf="isExclusiveCoupon">
                    <ng-container *ngTemplateOutlet="couponFilled"></ng-container>
                </ng-container>
                <button mat-flat-button color="accent" class="ut-pro-button gradient width-30" (click)="applyDiscount()" [disabled]="!discountForm.get('discountCoupon').value" *ngIf="!couponApplied || !isCouponValid, else removeBlock">
                    Apply
                </button>
                <ng-template #removeBlock>
                    <button mat-flat-button class="undeploy-button gradient width-30 border-radius-10" (click)="removeDiscount()" [disabled]="!discountForm.get('discountCoupon').value">
                        Remove
                    </button>
                </ng-template>
            </form>

            <ng-container *ngIf="!isExclusiveCoupon">
                <ng-container *ngTemplateOutlet="couponFilled"></ng-container>
            </ng-container>

        </mat-expansion-panel>
    </mat-accordion>

    <div class="font-bold font-14 margin-8-bottom pad-8-hr flex-space-between margin-8-top">
        <div class="payment-heading">
            Payment Details
        </div>
        <div class="mat-icon-14 flex-centered-container-vr check-box-14">
            <mat-checkbox class="high-elevated font-12 font-bold" [(ngModel)]="isAutoPayOn" [disabled]="planData.isRestrictedPlan">
                <span class="flex-centered-container-vr">
                    Set Up Autopay
                </span>
            </mat-checkbox>
            <mat-icon appTooltip svgIcon="info" [tooltip]="planData.isRestrictedPlan ? AUTO_PAY_DISABLED_ON_RESTRICTED_PLAN_SUBSCRIPTION(planData.planName) : AUTO_PAY_INFO " [top]="86" [left]="200"
                class="pad-4-left"></mat-icon>
        </div>
    </div>

    <div class="pad-8-hr">
        <div class="flex-space-between font-12 policies-text margin-8-bottom">
            <span class="mat-icon-12"> {{ planData.isDiyPlan ? 'Platform Fee' : 'Brokerage Charges' }}
                <mat-icon *ngIf="showUpgradeInfoTooltip" appTooltip svgIcon="info" [tooltip]="UPGRADE_INFO_TOOLTIP"
                    [left]="180" class="pad-4-left brokerage-icon" [widthClass]="'width-400'" [fontSize]="12">
                </mat-icon>
            </span>
            <span>{{CURRENCY_LABEL}} {{planOrderSummaryAfterDiscount?.estimate?.sub_total | precision: DEFAULT_PRECISION | nullCheck}}</span>
        </div>
        <div *ngIf="couponApplied && isCouponValid">
            <div class="flex-space-between font-12 policies-text margin-8-bottom">
                <div class="flex-centered-container-vr mat-icon-12">
                    <span>
                        {{hasNegativeFunds ? 'Max': ''}} Discount
                        ({{(couponDetails?.discount_type === DiscountType.PERCENTAGE)
                        ? planOrderSummaryAfterDiscount?.estimate?.discount_value  + '%'
                        : CURRENCY_LABEL + ' ' + planOrderSummaryAfterDiscount?.estimate?.discount_value
                        }})
                    </span>
                    <mat-icon *ngIf="hasNegativeFunds" appTooltip svgIcon="info" [tooltip]="NEGATIVE_FUND_STRING" [top]="115" [left]="165"
                        class="pad-4-left" [widthClass]="'width-400'"></mat-icon>
                </div>
                <span> - {{CURRENCY_LABEL}}
                    {{planOrderSummaryAfterDiscount?.estimate?.discount |
                    precision: DEFAULT_PRECISION
                    | nullCheck}}</span>
            </div>
            <mat-divider class="mat-divider margin-8-bottom"></mat-divider>
            <div class="flex-space-between font-12 policies-text margin-8-bottom">
                <span>Discounted Charges</span>
                <span>{{CURRENCY_LABEL}} {{(planOrderSummaryAfterDiscount?.estimate?.sub_total - planOrderSummaryAfterDiscount?.estimate?.discount) | precision: DEFAULT_PRECISION
                    | nullCheck}}</span>
            </div>
        </div>
        <div class="flex-space-between font-12 policies-text margin-8-bottom ">
            <span>
                GST Charges
                ({{planOrderSummaryAfterDiscount?.estimate?.taxes[0]?.percentage}}%)
            </span>
            <span>{{CURRENCY_LABEL}} {{planOrderSummaryAfterDiscount?.estimate?.taxes[0]?.amount | precision: DEFAULT_PRECISION
                | nullCheck}}</span>
        </div>
        <div *ngIf="planOrderSummaryAfterDiscount?.estimate?.credits_applied">
            <mat-divider class="mat-divider margin-8-bottom"></mat-divider>
            <div class="flex-space-between font-12 policies-text margin-8-bottom">
                <span>Net Charges</span>
                <span>{{CURRENCY_LABEL}} {{planOrderSummaryAfterDiscount?.estimate?.total | precision: DEFAULT_PRECISION
                    | nullCheck}}</span>
            </div>
            <div class="flex-space-between font-12 policies-text margin-8-bottom" *ngIf="!downgradablePlan">
                <span class="flex-centered-container-vr mat-icon-12">
                    <span>Allocation</span>
                    <mat-icon appTooltip svgIcon="info" [tooltip]="ALLOCATION_TEXT"
                    [top]="90" [left]="120" class="pad-4-left" [widthClass]="'width-400'"></mat-icon>
                </span>
                <span> - {{CURRENCY_LABEL}} {{planOrderSummaryAfterDiscount?.estimate?.credits_applied | precision:
                    DEFAULT_PRECISION |
                    nullCheck}}</span>
            </div>
        </div>
        <mat-divider class="mat-divider margin-8-bottom"></mat-divider>
        <div class="flex-space-between font-12 policies-text margin-8-bottom">
            <span>Required funds</span>
            <span>{{CURRENCY_LABEL}} {{planOrderSummaryAfterDiscount?.estimate?.amount_due | precision: DEFAULT_PRECISION
                | nullCheck}}</span>
        </div>
    </div>

    <mat-accordion class="margin-24-bottom custom-accordian" *ngIf="!downgradablePlan">
        <mat-expansion-panel [expanded]="isBalanceSummmaryExpanded">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div class="flex-space-between full-width">
                        <span  class="font-bold font-14 payment-heading">Balance Summary</span>
                        <span class="font-10 pad-4-vr pad-8-hr chamfer-xl" [ngClass]="{'sufficient-balance': !isBalanceSummmaryExpanded, 'insufficient-balance' : isBalanceSummmaryExpanded}">
                            {{isBalanceSummmaryExpanded ? 'Insufficient Balance' : 'Sufficient Balance'}}
                        </span>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="flex-space-between margin-8-top font-12 full-width policies-text">
                    <span>Available Funds</span>
                    <span>{{CURRENCY_LABEL}} {{availableFunds | unitFormatter:true:DEFAULT_PRECISION }}</span>
            </div>
        </mat-expansion-panel>
    </mat-accordion>


    <div class="full-width flex-centered-container" *ngIf="!downgradablePlan; else optionsBtn">
        <button *ngIf="!isBalanceSummmaryExpanded, else addFund" mat-flat-button color="accent" class="ut-pro-button width-90 gradient margin-24-top" (click)="subscribePlan()">
            Subscribe Now
        </button>
        <ng-template #addFund>
            <button mat-flat-button color="accent" class="ut-pro-button width-90 gradient margin-8-top" (click)="redirectToAddFunds()">
                Add Funds
            </button>
        </ng-template>
    </div>
    <ng-template #optionsBtn>
        <div class="flex-space-between">
            <button mat-flat-button color="accent" (click)="closeDialog()"
                class="ut-pro-button margin-top width-40 pad-4 gradient border-radius-8 margin-left-24">
                No
            </button>
            <button mat-flat-button color="accent" (click)="subscribePlan()"
                class="ut-pro-button margin-top pad-4 width-40 gradient-warn border-radius-8 margin-24-right">
                Yes
            </button>
        </div>
    </ng-template>

    <div class="mat-icon-10 text-center" *ngIf="!downgradablePlan">
        <span class="text-center font-10 margin-8-top policies-text">Payment will be debited from the withdrawal margin component of your Broker account</span>
        <mat-icon appTooltip svgIcon="info" [tooltip]="WITHDRAWAL_MARGIN_FORMULA" [top]="86" [left]="200"
            class="pad-4-left"></mat-icon>
    </div>
</div>

<ng-template #couponFilled>
    <div *ngIf="couponApplied">
        <div class="text-positive font-10 display-flex mat-icon-10" *ngIf="isCouponValid, else errorBlock">
            <mat-icon svgIcon="offer" class="margin-4-right"></mat-icon>
            <p class="no-margin">
                {{(couponDetails?.discount_type === DiscountType.PERCENTAGE)
                    ? planOrderSummaryAfterDiscount?.estimate?.discount_value + '%'
                    : CURRENCY_LABEL + ' ' + planOrderSummaryAfterDiscount?.estimate?.discount_value
                }}
                off Coupon successfully applied
            </p>
        </div>
        <ng-template #errorBlock>
            <div class="text-danger font-10 display-flex">
                <mat-icon svgIcon="invalid" class="margin-4-right"></mat-icon>
                <p class="no-margin">{{ invalidCouponError }}</p>
            </div>
        </ng-template>
    </div>
</ng-template>